/**
 * @class Const
 */
export class Const {
    static ERROR_MESSAGE_EXIST_EMAIL = '入力されたメールアドレスは既に使用されています。'
    static ERROR_MESSAGE_NOT_EXIST_EMAIL_OR_TEL = '連絡先電話番号 または メールアドレス に誤りがあります。'

    static KEY_RESPONSE_BAD_REQUEST_TYPE_VALIDATE = 'validate_error'
    static KEY_RESPONSE_BAD_REQUEST_TYPE_AUTH_KEY = 'auth_key_error'

    static PROVISION_STORE_CODE = 'PRS0000001'

    /** 製品登録入力画面 /product_registration/input/?uniqcode=uniqCode */
    static LOGIN_BACK_URL_CODE_PRODUCT_INPUT = '1'
    /** メールマガジン配信設定 /customer/mail_magazine */
    static LOGIN_BACK_URL_CODE_MAILMAGAZINE_INPUT = '2'
    /** マイページ /mypage */
    static LOGIN_BACK_URL_CODE_MYPAGE = '3'
    /** 製品登録完了 /product_registration/complete */
    static LOGIN_BACK_URL_CODE_PRODUCT_COMPLETE = '4'
    /** メールマガジン配信設定完了 /customer/mail_magazine/complete */
    static LOGIN_BACK_URL_CODE_MAILMAGAZINE_COMPLETE = '5'
    /** 製品登録履歴一覧 /products */
    static LOGIN_BACK_URL_CODE_REGISTED_PRODUCT_LIST = '6'
    /** 獲得バッジ一覧 /badges */
    static LOGIN_BACK_URL_CODE_EARNED_BADGE_LIST = '7'
    /** 特典商品選択 /badges/benefit/products/?pk=benefitPkey */
    static LOGIN_BACK_URL_CODE_BENEFIT_PRODUCT_INPUT = '8'
    /** 特典商品選択完了 /badges/benefit/products/complete/?pk=benefitPkey */
    static LOGIN_BACK_URL_CODE_BENEFIT_PRODUCT_COMPLETE = '9'

    /** キャンペーン一覧 /campaign */
    static LOGIN_BACK_URL_CODE_CAMPAIGN_LIST = '10'
    /** 特典商品選択 /campaign/benefit/products/?pk=benefitPkey */
    static LOGIN_BACK_URL_CODE_BENEFIT_PRODUCT_INPUT_CAMPAIGN = '11'
    /** 特典商品選択完了 /campaign/benefit/products/complete/?pk=benefitPkey */
    static LOGIN_BACK_URL_CODE_BENEFIT_PRODUCT_COMPLETE_CAMPAIGN = '12'

    /** @type {number} 翌年用の固定値 */
    static NEXT_YEAR = 2026
    /** @type {number} 今年用の固定値 使用しない場合は、0に変更する */
    static CURRENT_YEAR = 0

    /** @type {number} 2025年以降対応のデータ */
    static VERSION_AFTER_2025 = 2025
}
